import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { TipoConsorcio } from "../models/tipo-consorcio.model";

@Injectable()
export class TipoConsorcioService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Tipo de Consórcio por id
     * @param id ID da Tipo de Consórcio
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "consorcio/tipo-consorcio/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Tipo de Consórcio
     * @param id ID da Tipo de Consórcio
     */
    getAll(params: any): Observable<ApiPaginationResponseDataNonNullable<TipoConsorcio>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp !== null && paramHttp !== "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<TipoConsorcio>>(
            this.utilitesService.urlPrefix + "consorcio/tipo-consorcio" + env,
            {
                headers: this.authService.getAuthHeaders(),
            }
        );
    }

    /**
     * Lista de Tipo de Consórcio
     * @param id ID da Tipo de Consórcio
     */
    search(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "consorcio/tipo-consorcio" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de Tipo de Consórcio
     * @param id ID da Tipo de Consórcio
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "consorcio/tipo-consorcio/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Tipo de Consórcio
     * @param params Json Tipo de Consórcio
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "consorcio/tipo-consorcio", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza Tipo de Consórcio
     * @param params Json Tipo de Consórcio
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "consorcio/tipo-consorcio/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
